import { shellStringResources } from '../../Resources/ShellStringResources';
import { format, stringIsNullOrEmpty } from '../../shared/utils/string.util';
import { IModel } from '../base/annotation';
import { Metamodel } from '../base/model';
import { ExpressCustomSetup, expressCustomSetupTypes } from './expressCustomSetup';

@Metamodel.model({
    name: 'AzPowerShellCommand',
    display: [shellStringResources.ModelName_AzPowerShellExtension, shellStringResources.ModelName_AzPowerShellExtensions]
})
export class AzPowerShellSetup extends ExpressCustomSetup {
    public static readonly MODEL: IModel;

    public version: string;

    constructor(name?: string, public description?: string) {
        super(expressCustomSetupTypes.AzPowerShell, name, description);
    }

    public getCustomSetupName(): string {
        return format(shellStringResources.IRCreation_SSIS_CustomSetup_AzPowerShell_Format, this.version);
    }

    public coincideWith(customSetup: ExpressCustomSetup): void {
        if (this.customSetupType === customSetup.customSetupType) {
            const setup = customSetup as AzPowerShellSetup;
            this.version = setup.version;
        }
    }

    public validate(): boolean {
        return !stringIsNullOrEmpty(this.version) && this.version.indexOf(' ') === -1;
    }
}
